import type { FaireProductEntity } from "../../entity_types/product";

export const p_s86r2pkv42: FaireProductEntity = {
  token: "p_s86r2pkv42",
  type: "product",
  name: '3" Porcelain Mini Shell Dish - Microwave & Dishwasher Safe',
  brandName: "Crover",
  imageUrl:
    "https://cdn.faire.com/fastly/1eac02ee279f4a5da33c029b08f347491440d2fcc5c4ed477135f65a1c29c691.jpeg",
  priceDollars: 0.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/95f56c794874baab13dc7a0b67bc8060fc2f358c475df45fc8f1e770e788a6a4.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
